import { render, staticRenderFns } from "./NewCommonSwiper.vue?vue&type=template&id=20f8f2d2"
import script from "./NewCommonSwiper.vue?vue&type=script&lang=js"
export * from "./NewCommonSwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports